/**
 * Global axios interceptors — mirror the RTK Query baseQueryWithLoader for
 * all raw axios calls (send-email, generate-quote-pdf, etc.).
 * Import this file ONCE at the app entry point (index.tsx).
 */
import axios from "axios";
import store from "../Store";
import { decrementPending, incrementPending } from "../Store/loaderSlice";

axios.interceptors.request.use(
  (config) => {
    store.dispatch(incrementPending());
    return config;
  },
  (error) => {
    // Request setup itself failed — still decrement so counter stays accurate
    store.dispatch(decrementPending());
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    store.dispatch(decrementPending());
    return response;
  },
  (error) => {
    store.dispatch(decrementPending());
    return Promise.reject(error);
  }
);
